import React from "react";
import { images } from "../data/images";
import useScrollReveal from "../hooks/useScrollReveal";
import "./SunNeverStops.css";

export default function SunNeverStops() {
  const sectionRef = useScrollReveal(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".sun-stops__title span, .sun-stops__content p"), {
      y: 30,
      opacity: 0,
      duration: 0.8,
      stagger: 0.1,
      ease: "power3.out",
      scrollTrigger: { trigger: el, start: "top 75%" },
    });

    gsap.to(el.querySelector(".sun-stops__image"), {
      yPercent: 14,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.6,
      },
    });
  }, []);

  return (
    <section className="sun-stops" ref={sectionRef}>
      <div
        className="sun-stops__image"
        style={{ backgroundImage: `url(${images.aerialPanels})` }}
        aria-hidden="true"
      />
      <div className="sun-stops__disc" aria-hidden="true" />
      <div className="sun-stops__scrim" aria-hidden="true" />
      <div className="container sun-stops__content">
        <h2 className="sun-stops__title">
          THE SUN
          <br />
          <span className="accent-text">NEVER STOPS.</span>
        </h2>
        <p>Neither should progress.</p>
      </div>
    </section>
  );
}
